<!-- #63 -->
<template>
  <v-col class="mx-3">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Driver Feedback
      </div>
      <v-spacer> </v-spacer>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-card>
      <v-card-text>
        <v-form ref="form" @submit.prevent="save" type="submit">
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="tokenNumber"
                label="Token Number"
                :rules="[
                  (v) => (v && !!v.trim()) || 'Token Number is required.',
                ]"
                class="required"
                outlined
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-btn color="primary" :loading="loader" @click="save" class="mt-8"
              >Search</v-btn
            >
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card v-if="gettokenDetails.token_number">
      <v-card-title class="card-title pl-3">Token Details </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-3">
        <v-row class="pl-0 mr-0">
          <v-col cols="12" md="4">
            <div class="col-md-12 d-flex p-0 m-0">
              <div class="col-md-4 p-0 text-medium-emphasis">Token Number:</div>
              <div class="text-left col-md-7 p-0">
                <b> {{ gettokenDetails.token_number }}</b>
              </div>
            </div>
            <div class="col-md-12 d-flex p-0 m-0">
              <div class="col-md-4 p-0">Warehouse:</div>
              <div class="text-left col-md-7 p-0">
                <b> {{ gettokenDetails.wms_warehouse_code }}</b>
              </div>
            </div>
            <div class="col-md-12 d-flex p-0 m-0">
              <div class="col-md-4 p-0">Delivery Date:</div>
              <div class="text-left col-md-7 p-0">
                <b> {{ gettokenDetails.delivery_date }}</b>
              </div>
            </div>
            <div class="col-md-12 d-flex p-0 m-0">
              <div class="col-md-4 p-0">Purpose:</div>
              <div class="text-left col-md-7 p-0">
                <b> {{ gettokenDetails.purpose }}</b>
              </div>
            </div>
            <div class="col-md-12 d-flex p-0 m-0">
              <div class="col-md-4 p-0">Supplier Name:</div>
              <div class="text-left col-md-7 p-0">
                <b> {{ gettokenDetails.supplier_name }}</b>
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="4" class="pl-0">
            <div class="col-md-12 d-flex p-0 m-0">
              <div class="col-md-7 p-0">Driver Name:</div>
              <div class="text-left col-md-4 p-0">
                <b> {{ gettokenDetails.driver_name }}</b>
              </div>
            </div>

            <div class="col-md-12 d-flex p-0 m-0">
              <div class="col-md-7 p-0">Additional name along with Driver:</div>
              <div class="text-left col-md-4 p-0">
                <b> {{ gettokenDetails.additional_name }}</b>
              </div>
            </div>
            <div class="col-md-12 d-flex p-0 m-0">
              <div class="col-md-7 p-0">Driver Number:</div>
              <div class="text-left col-md-4 p-0">
                <b> {{ gettokenDetails.driver_number }}</b>
              </div>
            </div>
            <div class="col-md-12 d-flex p-0 m-0">
              <div class="col-md-7 p-0">Driver licence Number:</div>
              <div class="text-left col-md-4 p-0">
                <b> {{ gettokenDetails.driver_license_number }}</b>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <div class="col-md-12 d-flex p-0 m-0">
              <div class="col-md-4 p-0">Type of vehicle:</div>
              <div class="text-left col-md-7 p-0">
                <b> {{ gettokenDetails.vehicle_type }}</b>
              </div>
            </div>
            <div class="col-md-12 d-flex p-0 m-0">
              <div class="col-md-4 p-0">Vehicle Number:</div>
              <div class="text-left col-md-7 p-0">
                <b> {{ gettokenDetails.vehicle_number }}</b>
              </div>
            </div>
            <div class="col-md-12 d-flex p-0 m-0">
              <div class="col-md-4 p-0">Event Status:</div>
              <div class="text-left col-md-7 p-0">
                <b> {{ gettokenDetails.latest_event_status }}</b>
              </div>
            </div>
            <div class="col-md-12 d-flex p-0 m-0">
              <div class="col-md-4 p-0">Report in time:</div>
              <div class="text-left col-md-7 p-0">
                <b>
                  {{
                    gettokenDetails.reported_in_datetime
                      | localMomentNew
                      | moment("DD MMM, YYYY hh:mm A")
                  }}
                </b>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-form ref="formRate" v-if="gettokenDetails.driver_feedback == true">
          <v-row class="pt-5 pl-30">
            <v-col cols="12" class="pt-0 pb-4">
              <div class="d-flex flex-wrap align-center">
                <div class="text-subtitle-1 mr-4">
                  <b>Rate overall experience:</b
                  ><i class="caption red--text">*</i>
                </div>
                <v-rating
                  v-model="rating"
                  color="yellow darken-3"
                  background-color="black lighten-3"
                  empty-icon="mdi-star-outline"
                  full-icon="mdi-star"
                  half-icon="mdi-star-half-full"
                  hover
                  length="10"
                  size="36"
                  :rules="[
                    (v) => {
                      return !!v || 'Rating is required.';
                    },
                  ]"
                  style="padding-left: 8%"
                  class="mr-2 mb-2"
                ></v-rating>
              </div>
              <div class="d-flex flex-wrap align-center">
                <div class="text-subtitle-1 mr-4">
                  <b>Rate for the Score:</b><i class="caption red--text">*</i>
                </div>
                <v-checkbox
                  v-for="(item, i) in [
                    'Safety',
                    'Helpful Staff',
                    'Speed of Loading/Unloading',
                  ]"
                  :key="i"
                  v-model="ratingStore"
                  :value="item"
                  class="mr-4 mb-2"
                  :rules="[(v) => (v && v.length > 0) || 'Rating is required.']"
                  hide-details
                  style="padding-left: 12%; margin-top: 0px"
                >
                  <span slot="label">{{ item }}</span>
                </v-checkbox>
              </div>
              <div class="d-flex flex-wrap align-center">
                <div class="text-subtitle-1 mr-4">
                  <b>Rate your experience with RSA Staff:</b
                  ><i class="caption red--text">*</i>
                </div>
                <v-rating
                  v-model="ratingRsa"
                  color="yellow darken-3"
                  background-color="black lighten-3"
                  empty-icon="mdi-star-outline"
                  full-icon="mdi-star"
                  half-icon="mdi-star-half-full"
                  hover
                  length="10"
                  size="36"
                  class="mr-2 mb-2"
                ></v-rating>
              </div>
              <v-textarea
                v-model="ratingComment"
                label="Comment"
                class="mt-4"
                outlined
                maxlength="300"
              ></v-textarea>
              <v-btn
                color="primary"
                class="mt-0"
                @click="submit"
                v-if="!feedbackDone"
              >
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-col>
</template>
<script>
import { axios } from "@/plugins/http-request.js";
import { mapActions } from "vuex";

export default {
  data: () => ({
    ratings: [],
    ratingRsa: null,
    rating: "",
    ratingStore: [],
    ratingComment: "",
    loader: false,
    gettokenDetails: {},
    tokenNumber: "",
    showMessage: true,
    feedbackDone: false,
  }),

  created() {
    this.tokenNumber = this.$route.params.id_token;
    this.callFunction();
  },

  methods: {
    ...mapActions(["snackBar"]),

    callFunction() {
      if (this.tokenNumber == undefined) {
        return;
      }
      this.loader = true;
      axios
        .get(`/api/pas/search_token?token_number=${this.tokenNumber}`)
        .then((res) => {
          this.loader = false;
          if (res.data.data.records.length == 0) {
            this.loader = false;
            this.snackBar({
              color: "error",
              message: "No Record Found",
            });
          } else {
            this.gettokenDetails = res.data.data.records[0];
            this.ratingRsa = this.gettokenDetails.rsa_staff_experience_rating;
            this.rating = this.gettokenDetails.delivery_experience_rating;
            this.ratingStore = this.gettokenDetails.reason_for_score.split(",");
            this.ratingComment = this.gettokenDetails.comments;
            if (this.ratingRsa) {
              this.feedbackDone = true;
            }
          }
        });
    },
    submit() {
      if (!this.$refs.formRate.validate()) {
        return;
      }

      if (!this.rating) {
        this.snackBar({
          color: "error",
          message: "Rating is required.",
        });
        return;
      }
      if (!this.ratingRsa) {
        this.snackBar({
          color: "error",
          message: "RSA Staff Rating is required.",
        });
        return;
      }

      let data = {
        token_number: this.tokenNumber,
        comments: this.ratingComment.trim(),
        rsa_staff_experience_rating: this.ratingRsa,
        delivery_experience_rating: this.rating,
        reason_for_score: this.ratingStore.join(","),
      };
      axios.post(`/api/pas-driver-feedback/create`, data).then((res) => {
        this.snackBar({
          color: "success",
          message: res.data.data.message,
        });
        this.callFunction();
        // this.gettokenDetails = {};
      });
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.callFunction();
    },
  },
};
</script>
<style scoped>
.p-0 {
  padding: 0px !important;
}
</style>
